// Chrome-handoff pairing token capture. This module MUST be imported before the
// router so the fragment is captured before any other code observes it.
// The token lives in module memory ONLY — never stored, logged or rendered.
let token = null;

function strip() {
  if (window.location.hash.startsWith("#pt=")) {
    window.history.replaceState(null, "", "/mobile-setup?ub=1");
  }
}

if (window.location.pathname === "/mobile-setup") {
  const m = window.location.hash.match(/^#pt=(.+)$/);
  if (m) {
    token = decodeURIComponent(m[1]);
    strip();
    // Embedding/analytics scripts may restore the original URL once, asynchronously.
    // Guard for the first few seconds so the fragment can never persist in the
    // address bar or session history.
    const iv = setInterval(strip, 250);
    setTimeout(() => clearInterval(iv), 6000);
    window.addEventListener("hashchange", strip);
  }
}

export const getHandoffToken = () => token;
